import React, {forwardRef} from 'react';
import styled from 'styled-components';

import {Link, LinkProps} from './link';

/*
 * Props.
 */

export type BlockLinkProps = LinkProps;

/*
 * Style.
 */

const StyledLink = styled(Link)`
  display: block;
`;

/*
 * Component.
 */

export const BlockLink = forwardRef<HTMLAnchorElement, BlockLinkProps>((props, ref) => (
  <StyledLink {...props} ref={ref} />
));
